import React, { Component } from 'react';
import SurveyRect from './Shared/SurveyRect';
import FormatText from '../Utils/TextFormatter';
import ScaleQuestionItem from './Shared/ScaleQuestionItem';
import Button from './Shared/Button';
import Animator from '../Animator';

export default class ImagePage extends Component {

    state = {
        isValid: true,
        ansInx:-1,
        answers:"",
        fullscreenImage: false,
        step: 1,
        pointerSeen: false,
    }

    componentDidMount(){
        this.animatePointer();
    }
    
    componentDidUpdate(){              
        this.animatePointer();
    }

    animatePointer(){
        if(this.props.isCurrent && !this.state.pointerSeen) {
            const pointerHint = document.getElementById("pointer_hint");
            this.setState({pointerSeen: true});
            setTimeout(()=>{               
                pointerHint.style.display = '';
                Animator.animate({
                    duration: 3000, 
                    timing: Animator.Ease.linear,
                    draw(progress) {
                        const angle = 20 + 20 * Math.sin(progress*30);
                        pointerHint.style.transform = `perspective(100px) rotateX(${angle}deg)`;
                        if(progress > 0.95){
                            pointerHint.style.display = 'none';
                        }
                    }
                })
            }, 3000);
        }
    }

    itemAnswerSelected = (itemIndex, itemKey, ansIndex)=>{
        ansIndex ++;

        let answer = {};
        answer[itemKey] = ansIndex;

        let _answers = Object.assign({}, this.state.answers);
        _answers[itemIndex] = answer;

        this.setState({answers: _answers}, this.validatePage );       
    }

    validatePage = () =>{
        const answers = this.state.answers;
        // let itemKey = "";
        let foundNext = false;
        Object.keys(answers).forEach((key,index)=>{          
            const value = answers[key][Object.keys(answers[key])[0]]; //works on Internet Explorer
            if(!foundNext && value === -1) {
                // itemKey = this.props.scaleItems[index].key;
                foundNext = true;
            }
        });
        if(!foundNext) {
            this.setState({isValid: true});
            return;
        }

        if(this.props.scaleItems.length < 3) return;
        // setTimeout(()=>{this.scrollToItem(itemKey)}, global.isMobile? 200 : 0);
    }

    render(){
        const {style, description, hasQuestion, question, qTextSize, image, scaleItems, scaleSize, scaleIndex, followingScreen, altButtonTitle} = this.props;
        const {fullscreenImage, step} = this.state;

        const padding = 28;

        const rootElement = document.getElementById("seker_root");
        const fullHeight = rootElement.clientHeight;
        const fullWidth = rootElement.clientWidth;

        let thumbBottom = 100;
        let thumbHeight = 200;
        let thumbRight = "50%";
        let thumbWidth = "100%";
        let thumbMarginRight = "-50%";
        
        if(step === 2 ){
            thumbBottom = padding;
            thumbHeight = 42;
            thumbRight = 0;
            thumbWidth = 120;
            thumbMarginRight = 0;
        }


        const thumbnailStyle = {
            transition: "all 0.15s ease-out",
            zIndex: 3,
            position: 'absolute',
            bottom: thumbBottom,
            right: thumbRight,
            marginRight: thumbMarginRight,
            width: thumbWidth,
            height: thumbHeight,
            overflow: 'hidden',
            backgroundColor: global.colorTheme.background,
            borderRadius: 4,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)"
        }
        
        const fullscreenStyle = {
            transition: "all 0.15s ease-out",
            zIndex: 999,
            position: 'absolute',
            bottom: global.isMobile ? -12 : -24,
            right: '50%',
            marginRight: -fullWidth / 2,
            width: fullWidth,
            height: fullHeight,
            overflow: 'visible',
            backgroundColor: 'black',
            cursor: 'pointer',
            borderRadius: global.isMobile? 0: 16,
            display: 'flex',
            alignItems: 'center',
        }

        let questionText;
        if(qTextSize === `small`){ 
            questionText = <div className="smallQuestion">{FormatText(global.isMale,question)}</div>
        }
        if(qTextSize === `medium`){ 
            questionText = <h3>{FormatText(global.isMale,question)}</h3>
        }
        if(qTextSize === `large`){ 
            questionText = <h2>{FormatText(global.isMale,question)}</h2>
        }

        const buttonText = (altButtonTitle !== "" && altButtonTitle !== undefined) ? altButtonTitle : "המשך";


		return <div key={'survrectcont'} style={style}>
            <SurveyRect {...this.props} H={440}>
                <div id="inner_surveyRect"  style={{
                    position: "absolute",
                    right: padding,
                    left: padding,
                    top: padding,
                    bottom: 0,
                    overflow: "scrollY",
                    textAlign: "right",
                }}>
                    {(description !== `` && step === 1) && <div className="preface">{FormatText(global.isMale,description)}</div>}
                    {(hasQuestion && question !== `` && step === 2) && questionText}
                    {(scaleIndex !== `` && step === 2) && <div className="scaleIndex">{FormatText(global.isMale,scaleIndex)}</div>}
                    <div className="separation-bar"/>
                    {(hasQuestion && step === 2) && <div style={{marginTop: 16, left: -padding}}> 
                        {scaleItems.map((item,i)=> {
                            const _itemKey = item.key;
                            const _condition = FormatText(global.isMale,item.condition);
                            return <ScaleQuestionItem key={i} itemIndex={i} itemKey={_itemKey} padding={padding} condition={_condition} scaleSize={scaleSize}
                                onClick={this.itemAnswerSelected}
                            />
                        })}
                        </div>}
                    <div key={'imgcont'} id="image_container" style={fullscreenImage ? fullscreenStyle : thumbnailStyle}
                        onClick={()=>{                            
                            this.setState({fullscreenImage: !fullscreenImage});
                        }}>
                        <img src={image} alt="img" style={{
                            width: "100%",
                            
                        }}/>
                        <div id="pointer_hint" style={{
                            position: 'absolute',
                            right: 12,
                            top: 12,
                            fontSize: 36,
                            display: 'none',
                        }}><span className="emoji" role="img" aria-label="Backhand Index Pointing Up">👆</span></div>
                    </div>                   
                </div>
                <Button style={{
                    position:"absolute",
                    left:padding,
                    bottom:padding,
                }} text={buttonText} isActive={this.state.isValid} onClick={()=>{
                    if(!hasQuestion){
                        global.nextStage(followingScreen);
                        return;
                    }

                    if(step === 2){
                        this.SetAnswer();
                    } else {
                        this.setState({step:2, isValid:false});
                    }
                }}/>
            </SurveyRect>
        </div>   
    }

    SetAnswer()
    {
        const answers = this.state.answers;

        Object.keys(answers).forEach((k,index)=>{
            const itemKey = Object.keys(answers[k])[0];
            const value = answers[k][Object.keys(answers[k])[0]];
            let ansKey = this.props.qKey;
            if(itemKey !== "") {ansKey += "_" + itemKey;}

            global.setAnswer(ansKey, value);
        });
        global.nextStage(this.props.followingScreen);
    }
}


// WEBPACK FOOTER //
// ./src/Comp/ImagePage.js